import React from 'react'
import loginArtwork3 from '../assets/loginArtwork3.svg'

export const LoginPoster = () => {
    return <img style={{ maxWidth: '100%' }} src={loginArtwork3} alt="login poster" />
}
